import { rootUri } from "@docsndata/thesmartwashltd-bookings-core";
export async function loadPaymentRequest(paymentRequest) {
    var _a;
    const url = `${rootUri()}/v1/thesmartwashltd.com/unpaidPaymentRequest?code=${paymentRequest}`;
    const response = await fetch(url);
    if (response.ok) {
        return response.json();
    }
    throw new Error(`Failed to fetch payment request: ${response.status} ${(_a = response.statusText) !== null && _a !== void 0 ? _a : ""}`);
}
